import { yup } from '@framework/validation';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { IntegerRuleComponent } from './IntegerRuleComponent';

const configValidator = yup
  .object({
    value: yup.boolean().notRequired().label('Solo numeri interi'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

type IRuleIntegerType = yup.InferType<typeof configValidator>;

export const IntegerRule: IRuleType<IRuleIntegerType> = {
  type: RuleType.Integer,
  name: 'Solo numeri interi',
  configComponent: IntegerRuleComponent,
  configValidator: configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    return (schema as yup.NumberSchema).integer(
      rule.customMessage ?? undefined,
    );
  },
};
